import React from 'react';
import { object, string, func } from 'prop-types';
import { connect } from 'react-redux';
import s from '../overviewWidget.module.css';
import sButton from '../../../../components/MLButton/MLButton.module.css';

const ReadAndPracticeOverviewWidget = ({
  rnpAssignment,
  btnText,
  getLaunchUrl,
}) => {
  const launchUrl = rnpAssignment.id
    ? getLaunchUrl({
        ...rnpAssignment,
        report: { name: 'autoStartTrends', value: '1' },
      })
    : '#';
  const disabledClass = rnpAssignment.id ? '' : s.disabled;

  return (
    <div className={[s.OverviewCard, s.OverviewRnPCard].join(' ')}>
      <div>
        <h2>Insight Snapshot</h2>
        <hr />
        <p>A snapshot of overall performance and class trends over time.</p>
        <a
          aria-label={btnText}
          className={`${s.viewRnPBtn} ${sButton.btnSecondary} ${disabledClass}`}
          href={launchUrl}
          data-test-id="course_performance_overview_button"
        >
          {btnText}
        </a>
      </div>
    </div>
  );
};

ReadAndPracticeOverviewWidget.propTypes = {
  btnText: string,
  rnpAssignment: object,
  getLaunchUrl: func,
};

function mapStateToProps(state) {
  return {
    rnpAssignment: state.reports.courseAbstract.readAndPracticeAssignment,
  };
}

export default connect(mapStateToProps)(ReadAndPracticeOverviewWidget);
